cv.TeamAppealView = Marionette.LayoutView.extend({
  template: cv.Templates["team/appeal"],

  regions: {
    region_appeal: "#region-appeal",
  },

  behaviors: [
    {
      behaviorClass: cv.FormBehavior,
    },
  ],

  events: {},

  initialize: function (options) {
    this.options = _.extend(this.options, options);

    // If save button is clicked and it's valid, we copy over the draft to appeal
    this.listenTo(
      this,
      "form:validated",
      function () {
        this.trigger("form:set", "description", this._model_clone.get("draft"));
      },
      this,
    );

    console.log("TeamAppealView initialized");
  },

  templateHelpers: function () {
    return {};
  },

  onAttach: function () {
    var view = new cv.Views.VueComponentView({
      component: "BaseRichText",
      defaultArgs: {
        props: {
          name: "Enter content...",
          value: this._model_clone.get("draft"),
        },
      },
    });
    view.on(
      "value_changed",
      function (val) {
        this._model_clone.set("draft", val);

        // Save the draft
        $.ajax({
          url: this.model.url(),
          data: {
            draft: val,
          },
          dataType: "json",
          type: "PUT",
          success: _.bind(function (data) {}, this),
          error: _.bind(function (data) {}, this),
        });
      },
      this,
    );
    this.showChildView("region_appeal", view);

    this.model.fetch({
      success: _.bind(function () {
        view.trigger("set_value", "value", this.model.get("draft"));
      }, this),
    });

    // Change document title
    document.title = "Team Setup | Write your Appeal";
  },
});
